export enum LabelSizes {
  little = 'text-xs', // font-size= 0.75rem line-height= 1rem
  small = 'text-sm', // font-size= 0.875rem line-height= 1.25rem
  medium = 'text-base', // font-size= 1rem line-height= 1.5rem
  large = 'text-lg', // font-size= 1.125rem line-height= 1.75rem
  extraLarge = 'text-xl', // font-size= 1.25rem line-height= 1.75rem;
}
